import { HStack } from '@chakra-ui/react'
import { mdiHistory, mdiMessagePlusOutline } from '@mdi/js'
import { PrimitiveAtom, useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import SquareButton from '@/components/buttons/square'
import { createChat, partialMessagesAtom } from '@/store/gigiChat/ChatAtom'
import {
    toggleChatHistoryMobileDrawer,
    toggleDocumentsHistoryMobileDrawer,
    toggleTranslateHistoryMobileDrawer,
} from '@/store/mobile/MobileAtom'
import { IShortMessageObject } from '@/types/gigiChat/Chat'
import { TProcessingStrategy } from '@/types/gigiChat/ConversationSettings'

const ActionButtons = ({ processingStrategy }: { processingStrategy?: TProcessingStrategy }) => {
    const { t } = useTranslation()
    const [partialMessage] = useAtom<PrimitiveAtom<Array<IShortMessageObject>>>(partialMessagesAtom)
    const [isDisabled, setIsDisabled] = useState(false)

    const handleClick = () => {
        switch (processingStrategy) {
            case 'QA':
            case 'Writing':
                toggleChatHistoryMobileDrawer()
                break
            case 'DocAnalysis':
                toggleDocumentsHistoryMobileDrawer()
                break
            case 'Translation':
                toggleTranslateHistoryMobileDrawer()
                break
        }
    }

    useEffect(() => {
        // If all the messages are fake (like welcome message or settings change)
        if (
            partialMessage.length &&
            partialMessage.filter((message) => message.answer === null && message.question === null).length === partialMessage.length
        ) {
            setIsDisabled(true)
        } else {
            setIsDisabled(false)
        }
    }, [partialMessage])

    return (
        <HStack gap="12px">
            <SquareButton
                dataID="chat-history"
                isDisabled={false}
                icon={mdiHistory}
                label={t('chat.settings.sections.history')}
                onClick={handleClick}
                tooltipPosition="top"
                dataTestId="chat-history-button"
            />
            <SquareButton
                dataID="chat-create"
                isDisabled={isDisabled}
                icon={mdiMessagePlusOutline}
                label={t('chat.newChat.buttonTitle')}
                onClick={() => void createChat(processingStrategy)}
                tooltipPosition="top"
                dataTestId="chat-new-chat-button"
            />
        </HStack>
    )
}

export default ActionButtons
